import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'react-awesome-reveal';
import { ProgressiveImage } from '../ProgressiveImage';
import { Button } from '../Button';
import styles from './CardSelectorStageMobile.css';

function CardSelectorStageMobile({cards, selectCard, finishStage, selectedCards, numberOfCards, children}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newCards, setNewCard] = useState(cards); 
    const currentCard = newCards[currentIndex];
    const prevCardSkippedRef = useRef(false);
    const numberOfCardsLeft = numberOfCards - selectedCards.length;

    const skipCard = card => () => {
        setNewCard(newCards => [...newCards, card]);
        setCurrentIndex(index => index + 1);
        prevCardSkippedRef.current = true;
    };

    const pickCard = card => () => {
        if (selectedCards.length + 1 === numberOfCards) {
            selectCard(card);
    
            return finishStage();
        }
    
        selectCard(card);
        setCurrentIndex(index => index + 1);
        prevCardSkippedRef.current = false;
    };

    return (
        <>
            <Fade
                triggerOnce
                duration={300}
                key={currentCard.id}
                className={styles.container}
            >
                <ProgressiveImage
                    alt='player'
                    src={currentCard.imageUrl}
                    className={styles.cardImage}
                />
                <p className={styles.cardsLeftText}>{numberOfCardsLeft} card{numberOfCardsLeft > 1 ? 's' : ''} left</p>
                {children(prevCardSkippedRef.current)}
                <div className={styles.buttons}>
                    <Button
                        type='fourth'
                        onClick={pickCard(currentCard)}
                        label={(
                            <>
                                Pick {currentCard.name}
                                <span style={{color: `var(--level-${currentCard.level})`}}>
                                    LVL 0{currentCard.level}
                                </span>
                            </>
                        )}
                    />
                    <Button
                        type='fourth'
                        onClick={skipCard(currentCard)}
                        label='Skip'
                    />
                </div>
            </Fade>
        </>
    );
};

CardSelectorStageMobile.propTypes = {
    cards: PropTypes.array.isRequired,
    selectedCards: PropTypes.array.isRequired,
    selectCard: PropTypes.func.isRequired,
    finishStage: PropTypes.func.isRequired,
    numberOfCards: PropTypes.number.isRequired,
    children: PropTypes.func.isRequired
};

export {
    CardSelectorStageMobile
};
